import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

import Header from '_components/header'
import { useUser } from '_hooks'

import AudienceInsightsBlock from './audience-insights.jsx'
import AudienceCreatorBlock from './audience-creator'
import DataFeedsBlock from './data-feeds'

import IconAnalytics from './icons/icon-analytics'
import IconAudience from './icons/icon-audience'
import IconDataFeeds from './icons/icon-data-feeds'

import { getAudiences, getFeeds, getInsights } from '_services/dashboard'

import DataSphereLogo from '../../../static/img/datasphere-logo-2.svg'

import './styles.scss'

const StatusCard = ({
  title,
  Icon = () => {
    return null
  },
  count,
}) => {
  return (
    <div className="dashboard__status-card">
      <div>
        <Icon size={50} fill="#13682B" />
      </div>
      <hr />
      <span>{count ? count : ''}</span>
      <p>{title}</p>
    </div>
  )
}

export const Block = ({ title, link, actions, content }) => {
  return (
    <div className="dashboard__block">
      <h2>
        <Link to={link}>{title}</Link>
      </h2>
      <div className="dashboard__actions">{actions}</div>
      <div className="dashboard__content mac-scrollbar" style={{ '--mac-scrollbar-bk': '#fafafa' }}>
        {content}
      </div>
    </div>
  )
}

const Dashboard = () => {
  const [statusCount, setStatusCount] = useState({
    creator: null,
    feeds: null,
    insights: null,
  })

  const { user } = useUser()

  useEffect(() => {
    const audiences = getAudiences()
    const feeds = getFeeds()
    const insights = getInsights()

    Promise.all([audiences, feeds, insights]).then((data) => {
      setStatusCount({
        creator: data[0].count,
        feeds: data[1].count,
        insights: data[2].length,
      })
    })
  }, [])

  if (!user?.email) return null

  return (
    <main className="dashboard">
      <Header className="dashboard__header">
        <DataSphereLogo style={{ width: 195 }} />
      </Header>
      <div className="dashboard__status">
        <StatusCard title="Audiences Created" Icon={IconAudience} count={statusCount.creator} />
        <StatusCard title="Data Feeds" Icon={IconDataFeeds} count={statusCount.feeds} />
        <StatusCard title="Insights Decks" Icon={IconAnalytics} count={statusCount.insights} />
      </div>
      <div className="dashboard__grid">
        <AudienceCreatorBlock currentUser={user.email} />
        <DataFeedsBlock currentUser={user.email} />
        <AudienceInsightsBlock currentUser={user.email} />
      </div>
    </main>
  )
}

export default Dashboard
